module.exports = __webpack_public_path__ + "img/background@2x.696cbdab.png";